import React from 'react';

import {CLOSE__12} from '@homeaway/svg-defs';

import FilterPill from '../FilterPill/FilterPill';

type Props = {
    onClick: Function;
    label: string;
};

export default function SelectedFilterPill({label, onClick}: Props) {
    return (
        <FilterPill
            applied
            appliedCount={0}
            onClick={onClick}
            leftAlign={false}
            icon={CLOSE__12}
            label={label}
            isSelectedFilter
        />
    );
}
